import type { components } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";

const WEB_PUSH_PUBLIC_KEY_PATH = "/v1/notification/web-push/public-key" as const;

type WebPushPublicKeyResponse = components["schemas"]["WebPushPublicKeyResponse"];

// Kept as a plain fetch (not a cached query) so each sync sees the current key and can detect rotation.
export async function fetchWebPushPublicKey(): Promise<string | null> {
  const response = await alphartisApiAxios.get<WebPushPublicKeyResponse>(WEB_PUSH_PUBLIC_KEY_PATH, {
    skipErrorHandling: true,
  });
  return response.data.publicKey;
}
